(function () {

  'use strict';

  function pxUnique($rootScope, $timeout) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, element, attributes, ngModelController) {

        let lastInvalidValue;

        (function () {
          if (angular.isUndefined($rootScope.pxUnique)) {
            $rootScope.pxUnique = {};
          }
          if (angular.isUndefined($rootScope.pxUnique[attributes.pxUnique])) {
            $rootScope.pxUnique[attributes.pxUnique] = [];
          }
          $rootScope.pxUnique[attributes.pxUnique].push(ngModelController);
        })();

        scope.$on('$destroy', function () {
          const index = $rootScope.pxUnique[attributes.pxUnique].indexOf(ngModelController);
          if (index !== -1) {
            $rootScope.pxUnique[attributes.pxUnique].splice(index, 1);
            if (angular.isDefined(ngModelController.$error.pxUnique)) {
              const otherModelControllers = $rootScope.pxUnique[attributes.pxUnique];
              clearValidationErrorOnOnlyInputWithSameValue(otherModelControllers);
            }
          }
        });

        ngModelController.$validators.pxUnique = function (modelValue, viewValue) {
          const value = modelValue || viewValue;
          return isUnique(value);
        };

        function isUnique(value) {
          const otherModelControllers = $rootScope.pxUnique[attributes.pxUnique].filter(modelController => modelController !== ngModelController);
          const wasValid = angular.isUndefined(ngModelController.$error.pxUnique);
          const isValid = ngModelController.$isEmpty(value) || otherModelControllers.reduce((count, modelController) => {
            return modelController.$viewValue === value ? ++count : count;
          }, 0) === 0;
          if (!wasValid) {
            clearValidationErrorOnOnlyInputWithSameValue(otherModelControllers);
          }
          if (!isValid) {
            lastInvalidValue = value;
            setValidationErrorOnOnlyInputWithSameValue(otherModelControllers);
          }
          return isValid;
        }

        function clearValidationErrorOnOnlyInputWithSameValue(otherModelControllers) {
          const modelControllers = otherModelControllers.filter(modelController => modelController.$viewValue === lastInvalidValue);
          if (modelControllers.length === 1 && angular.isDefined(modelControllers[0].$error.pxUnique)) {
            $timeout(() => modelControllers[0].$validate());
          }
        }

        function setValidationErrorOnOnlyInputWithSameValue(otherModelControllers) {
          const modelControllers = otherModelControllers.filter(modelController => modelController.$viewValue === lastInvalidValue);
          if (modelControllers.length === 1 && angular.isUndefined(modelControllers[0].$error.pxUnique)) {
            $timeout(() => modelControllers[0].$validate());
          }
        }

      }
    };
  }

  pxUnique.$inject = ['$rootScope', '$timeout'];

  angular
    .module('printix-admin')
    .directive('pxUnique', pxUnique);

})();
